export default __webpack_public_path__ + "static/media/img-0436-hungary-half-face.1554b332.png";